/**
 * 表示専用の概算料金計算(Phase「LIFF frontend実装」)。
 *
 * 重要: これは日時選択画面でユーザーに目安を見せるためだけの表示用計算
 * であり、正式な金額ではない。実際の金額は必ずbackend
 * (POST /v1/bookings のレスポンスamount、rental-booking/src/core/pricing.ts)
 * が再計算した値を正とする。祝日判定はGoogle Calendarに基づきサーバー側
 * でのみ確定できるため、この概算計算は「土/日」だけを休日相当として扱い、
 * 平日祝日は考慮しない(過小に見積もる場合がある。UI側に必ず「概算」と
 * 明記すること)。
 */

const HOURLY_RATE_YEN = 2_200;
const FLAT_RATE_YEN = 22_000;
const FLAT_RATE_THRESHOLD_HOURS = 10;

export function isWeekendDate(useDate: string): boolean {
  const day = new Date(`${useDate}T00:00:00`).getDay();
  return day === 0 || day === 6;
}

/** 概算金額(円)。祝日は考慮しない。durationは1〜13の整数を想定。 */
export function estimatePriceYen(useDate: string, durationHours: number): number {
  if (isWeekendDate(useDate)) return FLAT_RATE_YEN;
  if (durationHours >= FLAT_RATE_THRESHOLD_HOURS) return FLAT_RATE_YEN;
  return durationHours * HOURLY_RATE_YEN;
}
